import { PortableText } from '@portabletext/react'
import { Paragraph } from './text'
import { Image, XStack, YStack } from 'tamagui'
import { Tag } from './Tag'
import { Page, PageProps } from './Page'
import { format, parseISO } from 'date-fns'
import { Avatar } from './Avatar'

export type PagePortableTextProps = {
  pageProps?: PageProps
  item: {
    title: string
    mainImage?: string
    publishedAt: string
    authors?: { slug: string; title: string; position: string; image: string }[]
    categories?: {
      title: string
      slug: string
    }[]
    body: any[]
  }
}

export const PagePortableText = ({
  item,
  pageProps,
}: PagePortableTextProps) => {
  return (
    <Page name={item.title} containerSize="sm" {...pageProps}>
      <Paragraph
        textAlign="left"
        color="$neutral.600"
        fontWeight="semibold"
        fontStyle="italic"
        fontSize={'$sm'}
      >
        {format(new Date(parseISO(item.publishedAt)), 'MMMM dd, yyyy')}
      </Paragraph>
      {item.authors && item.authors.length > 0 ? (
        <YStack mb="$3">
          {item.authors.map((author) => {
            return (
              <XStack key={author.slug} mb="$4">
                <Avatar src={author.image} size="$9" mr="6" />
                <YStack>
                  <Paragraph size="$sm">{author.title}</Paragraph>
                  <Paragraph size="$xs" color="$neutral.600" lineHeight={1.1}>
                    {author.position}
                  </Paragraph>
                </YStack>
              </XStack>
            )
          })}
        </YStack>
      ) : null}
      {item.mainImage && (
        <Image
          src={item.mainImage}
          resizeMode="cover"
          width="100%"
          height={300}
          $gtSm={{ height: 300 }}
          $gtLg={{ height: 400 }}
          mb="$2"
        />
      )}
      {item.categories && item.categories.length > 0 ? (
        <XStack flexWrap="wrap">
          {item.categories.map((cat) => (
            <Tag
              colorScheme="primary"
              size="$md"
              mr="$2"
              mb="$4"
              key={cat.slug}
            >
              {cat.title}
            </Tag>
          ))}
        </XStack>
      ) : null}

      <PortableText value={item.body} />
    </Page>
  )
}
